// Copyright (c) Move Closer 2022.

import { Component, Vue } from 'vue-property-decorator'

import { Inject } from '../../../support'

import { IOrderStatusesService, OrderStatusesServiceType } from '../../orders/services/order-statuses'

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
@Component<OrderStatusesMixin>({
  name: 'OrderStatusesMixin',
  created () {
    this.initPossibleOrderStatuses()
    this.initHighlightedOrderStatuses()
    this.initRetryPaymentOrderStatuses()
    this.initReturnOrderStatuses()
  }
})
export class OrderStatusesMixin extends Vue {
  @Inject(OrderStatusesServiceType)
  public readonly orderStatusesService!: IOrderStatusesService

  public _possibleOrderStatuses!: Record<string, string>
  public _highlightedOrderStatuses!: Record<string, string>
  public _retryPaymentOrderStatuses!: Record<string, string>
  public _returnOrderStatuses!: Record<string, string>

  public get possibleOrderStatuses (): Record<string, string> {
    return this._possibleOrderStatuses
  }

  public get highlightedOrderStatuses (): Record<string, string> {
    return this._highlightedOrderStatuses
  }

  public get retryPaymentOrderStatuses (): Record<string, string> {
    return this._retryPaymentOrderStatuses
  }

  public get returnOrderStatuses (): Record<string, string> {
    return this._returnOrderStatuses
  }

  /**
   * Stores possible order statuses for application
   * @protected
   */
  protected initPossibleOrderStatuses (): void {
    const available = this.orderStatusesService.getStatuses()

    const entries = []
    for (const status of available) {
      entries.push([status, this.$t(`front.orders.possibleStatuses.${status}`).toString()])
    }

    this._possibleOrderStatuses = Object.fromEntries(entries)
    this.$store.commit('orders/setPossibleOrderStatuses', Object.fromEntries(entries))
  }

  /**
   * @protected
   */
  protected initHighlightedOrderStatuses (): void {
    const highlightedOrd = this.orderStatusesService.getHighlightedStatuses()

    if (!this._possibleOrderStatuses) {
      return
    }

    this._highlightedOrderStatuses = Object.fromEntries(
      Object.entries(this._possibleOrderStatuses).filter(([key, value]) => highlightedOrd.includes(key))
    )
  }

  /**
   * @protected
   */
  protected initRetryPaymentOrderStatuses (): void {
    const retryOrd = this.orderStatusesService.getRetryStatuses()

    if (!this._possibleOrderStatuses) {
      return
    }

    this._retryPaymentOrderStatuses = Object.fromEntries(
      Object.entries(this._possibleOrderStatuses).filter(([key, value]) => retryOrd.includes(key))
    )
  }

  /**
   * @protected
   */
  protected initReturnOrderStatuses (): void {
    const returnOrd = this.orderStatusesService.getReturnStatuses()

    if (!this._possibleOrderStatuses) {
      return
    }

    this._returnOrderStatuses = Object.fromEntries(
      Object.entries(this._possibleOrderStatuses).filter(([key, value]) => returnOrd.includes(key))
    )
  }
}
